import { render, staticRenderFns } from "./withdrawal-codes-list.vue?vue&type=template&id=4d6ed969"
import script from "./withdrawal-codes-list.vue?vue&type=script&lang=js"
export * from "./withdrawal-codes-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/withdrawal-codes-list/withdrawal-codes-list.vue
// module id = B3P/
// module chunks = 0